import React from "react";
import { clients } from "../mockdata";
import { Helmet } from "react-helmet";

const ClientsPage = () => {
  return (
    <>
      <Helmet>
        <title>Clients | Milstone Associates</title>
        <meta
          name="description"
          content="Discover the valued clients of Milstone Associates and our long-standing partnerships in the MEP industry."
        />
        <meta property="og:title" content="Clients | Milstone Associates" />
        <meta
          property="og:description"
          content="Discover the valued clients of Milstone Associates and our long-standing partnerships in the MEP industry."
        />
        <meta property="og:image" content="/images/logo.webp" />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className="min-h-screen bg-slate-50 flex flex-col items-center">
        {/* Top: All Clients over Panoramic Image with White Overlay */}
        <div className="relative w-full h-80 md:h-[420px] lg:h-[520px] flex items-center justify-center mb-10">
          <img
            src="/images/Picture1.webp"
            alt="Clients panoramic"
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-white/60" />
          <h1 className="relative z-10 text-3xl md:text-5xl font-extrabold text-gray-900 text-center drop-shadow-lg mb-1">
            All Clients
          </h1>
        </div>
        {/* Main Content: Clients Grid */}
        <div className="max-w-7xl w-full flex flex-col items-center px-12">
          <div className="w-20 h-1 bg-red-600 rounded mb-8"></div>
          <p className="text-gray-700 text-base md:text-lg mb-12 text-center">
            We are proud to have partnered with a diverse range of clients.
            Explore our full client list below.
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6 sm:gap-8 justify-items-center mb-8">
            {" "}
            {clients.map((client, idx) => (
              <div
                key={idx}
                className="bg-white rounded-lg shadow-lg w-28 sm:w-36 md:w-40 lg:w-44 aspect-square p-3 overflow-hidden flex items-center justify-center"
              >
                {" "}
                <img
                  src={client.logo}
                  alt={client.name}
                  className="h-full w-full object-contain"
                  title={client.name}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ClientsPage;
